var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePatient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.888672,
    width: 51,
    height: 51,
    rx: 14,
    fill: "#19BB7A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.3898 10.625C22.4925 10.625 19.3242 13.7934 19.3242 17.6906C19.3242 21.5135 22.314 24.6075 26.2113 24.7414C26.3303 24.7265 26.4494 24.7265 26.5386 24.7414C26.5683 24.7414 26.5833 24.7414 26.613 24.7414C26.6279 24.7414 26.6279 24.7414 26.6427 24.7414C30.4507 24.6075 33.4406 21.5135 33.4555 17.6906C33.4555 13.7934 30.2871 10.625 26.3898 10.625Z",
    fill: "#19BB7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9445 28.7001C29.7944 25.9333 23.0262 25.9333 18.8464 28.7001C16.9573 29.9645 15.916 31.675 15.916 33.5046C15.916 35.3343 16.9573 37.03 18.8315 38.2795C20.914 39.6778 23.651 40.3769 26.388 40.3769C29.125 40.3769 31.862 39.6778 33.9445 38.2795C35.8188 37.0152 36.86 35.3195 36.86 33.4749C36.8452 31.6453 35.8188 29.9496 33.9445 28.7001Z",
    fill: "#19BB7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2852 33.4818L25.3643 35.561L29.4946 31.4336",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePatient);
export default __webpack_public_path__ + "static/media/ActivePatient.c0fc2769e9bb326206d1c74d8981875d.svg";
export { ForwardRef as ReactComponent };